var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenu = function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45.2 39.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45.2v13.3H0zM0 26.5h45.2v13.3H0z",
    className: "icon_menu_svg__st0"
  })));
};
export default SvgIconMenu;